// Module
var code = "<!DOCTYPE html>\n<div class=\"iw-time-range__info__popover d-flex flex-column justify-content-center align-items-center text-center\"></div>";
// Exports
export default code;